import { useTheme } from "@mui/material"
import { useContextState } from "../../../../../../../../hooks/theme"

export const useStyles = () => {
  const { colors } = useContextState()
  const { breakpoints } = useTheme()
  return {
    container:(selected:boolean) => ({
        border: "1px solid #ddd",
        borderRadius: 2,
        p: 2,
        boxShadow: 1,
        backgroundColor: selected ? "#1976d2" : "#f9f9f9",
        color: selected ? "#fff" : colors.color9,
        transition: "background-color 0.3s ease",
        cursor: "pointer",
        '&:hover': {
          backgroundColor: selected ? "#1565c0" : "#f0f0f0",
        },
        display: "flex",
        //alignItems: "center",
        height: "100%",
        width:'100%'
        //minHeight:'165px'
    }),
    secondContainer :{ 
        display: "flex", 
        //alignItems: "center", 
        mr: 2,
        '& .MuiSvgIcon-root':{
          fontSize:'2rem'
        }
    },
    column: { 
        display: "flex", 
        flexDirection: "column",
        gap: 1
    }
  }
}